export default {
  pix: '',
  phoneNumber: '',
  smsTimeoutKey: 'sms-timeout'
}
